/* NikitasTCG – Conversion-Booster
   1) Gratisversand-Fortschritt + Produktvorschläge in Cart-Drawer und Warenkorbseite (per Section Rendering API)
   2) Vorschläge per AJAX in den Warenkorb legen */
(function () {
  if (window.__ntBoost) return; window.__ntBoost = true;
  var SEC = 'nikitas-cart-boost';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false, queued = false, selfMut = false, timer = null;

  function strip(scope) { scope.querySelectorAll('.nt-boost,.nt-checkout-trust').forEach(function (n) { n.remove(); }); }

  async function getParts() {
    var r = await fetch(root + '?sections=' + SEC, { credentials: 'same-origin' });
    var j = await r.json();
    var d = document.createElement('div'); d.innerHTML = j[SEC] || '';
    return { bar: d.querySelector('.nt-boost--bar'), recs: d.querySelector('.nt-boost--recs'), trust: d.querySelector('.nt-checkout-trust') };
  }

  async function inject() {
    if (busy) { queued = true; return; }
    var drawer = document.querySelector('cart-drawer');
    var page = document.querySelector('#main-cart-items .js-contents');
    if (!drawer && !page) return;
    busy = true;
    try {
      var p = await getParts();
      selfMut = true;
      if (drawer) {
        strip(drawer);
        var empty = drawer.classList.contains('is-empty') || !drawer.querySelector('#CartDrawer-CartItems .cart-item');
        if (empty) {
          var ec = drawer.querySelector('.cart-drawer__empty-content');
          if (ec && p.recs) ec.appendChild(p.recs.cloneNode(true));
        } else {
          var items = drawer.querySelector('#CartDrawer-CartItems');
          if (items && p.bar) items.prepend(p.bar.cloneNode(true));
          var wrap = drawer.querySelector('.drawer__cart-items-wrapper');
          if (wrap && p.recs) wrap.after(p.recs.cloneNode(true));
          var ctas = drawer.querySelector('.drawer__footer .cart__ctas');
          if (ctas && p.trust) ctas.after(p.trust.cloneNode(true));
        }
      }
      if (page && page.querySelector('.cart-item')) {
        strip(page.closest('cart-items') || page);
        if (p.bar) page.prepend(p.bar.cloneNode(true));
        if (p.recs) page.append(p.recs.cloneNode(true));
        var fctas = document.querySelector('#main-cart-footer .cart__ctas');
        if (fctas && p.trust) { strip(document.getElementById('main-cart-footer')); fctas.after(p.trust.cloneNode(true)); }
      }
    } catch (e) { /* still: Shop funktioniert ohne Booster */ }
    finally {
      setTimeout(function () { selfMut = false; }, 0);
      busy = false;
      if (queued) { queued = false; schedule(); }
    }
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(inject, 120); }

  function watch() {
    var targets = [document.querySelector('cart-drawer'), document.getElementById('main-cart-items'), document.getElementById('main-cart-footer')].filter(Boolean);
    var mo = new MutationObserver(function (muts) {
      if (selfMut) return;
      var relevant = muts.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) { return n.nodeType === 1 && !(n.classList && (n.classList.contains('nt-boost') || n.classList.contains('nt-checkout-trust'))); });
      });
      if (relevant) schedule();
    });
    targets.forEach(function (t) { mo.observe(t, { childList: true, subtree: true }); });
    inject();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();

  /* Vorschlag in den Warenkorb */
  document.addEventListener('click', async function (e) {
    var b = e.target.closest('.nt-boost__add');
    if (!b) return;
    e.preventDefault();
    var label = b.textContent; b.disabled = true; b.textContent = '…';
    var drawer = document.querySelector('cart-drawer');
    var onCartPage = /\/cart\/?$/.test(location.pathname);
    var body = { id: Number(b.dataset.variant), quantity: 1 };
    var useDrawer = drawer && !onCartPage && typeof drawer.getSectionsToRender === 'function';
    if (useDrawer) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = location.pathname;
    }
    try {
      var r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      var j = await r.json();
      if (!r.ok) { b.textContent = 'Nicht verfügbar'; return; }
      if (useDrawer && j.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(j);
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) { try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nt-boost', cartData: j }); } catch (x) {} }
      } else { location.reload(); }
    } catch (err) { b.disabled = false; b.textContent = label; }
  });
})();
